
export default {
  download: {
    documentTitle: 'ORS route',
    download: 'Download',
    downloadFileName: 'Download file name',
    downloadFormat: 'Download format',
    downloadRoute: 'Download route',
    preparingDownload: 'Preparing download ...',
    fileReady: 'File ready',
    errorPreparingFile: 'Error preparing file',
    fileTooBigToBeDownloaded: 'File too big to be downloaded',
    standard: 'Standard'
  }
}
